import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { PopupAction } from '../../../../common/popup/PopupAction'
import { resetStoreHeaderCompanyAnalysis } from '../../../../companyAnalysis/common/header/companyInfo/store/slice'
import EventEmitter, {
  DISABLE_BLOCK_NAVIGATION,
} from '../../../../helpers/EventEmitter'
import Button from './Button'
import { ButtonBlankTemplate } from './ButtonBlankTemplate'
import ButtonSubmit from './ButtonSubmit'
import CheckOutScreen from './CheckOutScreen'
import HandleKeepSetting from './HandleKeepSetting'
import Loading from './Loading'
import TemplateName from './TemplateName'
import classes from './index.module.scss'
import PanelList from './panelList'
import { PopupSettingFs } from './popupSettingFs'
import SettingLayout from './settingLayout'
import SettingPanel from './settingPanel'
import { resetDefault, selectIsKeepingSetting } from './store/slice'

const DetailTemplate = ({ goToTemplateTable, detailTemplate }) => {
  const dispatch = useDispatch()

  const { saveTemplate, path } = detailTemplate

  const [isShowPopupReset, setIsShowPopupReset] = useState(false)

  const isKeepingSetting = useSelector(selectIsKeepingSetting)

  const reset = () => {
    dispatch(resetDefault())
    if (isKeepingSetting) {
      dispatch(resetStoreHeaderCompanyAnalysis())
    }
    setIsShowPopupReset(false)
  }

  const goToTemplateAfterSave = () => {
    EventEmitter.dispatch(DISABLE_BLOCK_NAVIGATION, true)
    setTimeout(() => goToTemplateTable())
  }

  return (
    <Element style={{ color: '#3A414B' }} className={classes.preferenceSetting}>
      <div className={classes.header}>
        <Element
          style={{ fontSize: 24, color: '#0553A5' }}
          className={classes.title}
        >
          DYNAMIC REPORT
        </Element>
        <Button
          saveTemplate={saveTemplate}
          action={goToTemplateTable}
          disableShowPopupConfirm
        >
          <Element
            style={{ border: '1px solid #6D9DCF', color: '#0553A5' }}
            className={classes.btnTemplate}
          >
            <Icon
              style={{ color: '#0553A5', fontSize: 13 }}
              className="icon-folder"
            />
            <Translate value="preferenceSetting.SAVED_TEMPLATE" />
          </Element>
        </Button>
      </div>
      <div className={classes.information}>
        <TemplateName />
        <Element
          style={{ border: '1px solid #6D9DCF', color: '#0553A5' }}
          className={classes.btnReset}
          onClick={() => setIsShowPopupReset(true)}
        >
          <Icon
            style={{ color: '#0553A5', fontSize: 13 }}
            className="icon-reset2"
          />
          <Translate value="preferenceSetting.RESET" />
        </Element>
        <ButtonBlankTemplate saveTemplate={saveTemplate} />
      </div>
      <Element
        style={{ border: '1px solid #e8eaed' }}
        className={classes.contentContainer}
      >
        <Element
          style={{ backgroundColor: '#D5D5D5', fontSize: 14, color: '#191D25' }}
          className={classes.titleContent}
        >
          <Translate value="dynamicReport.CUSTOMIZE_REPORT" />
        </Element>
        <div className={classes.contentBorder}>
          <Element
            style={{ background: '#F3F3F3' }}
            className={classes.contentPanel}
          >
            <PanelList />
          </Element>
          <div className={classes.contentPanel}>
            <SettingLayout />
          </div>
          <div className={classes.contentPanel}>
            <SettingPanel />
          </div>
        </div>
      </Element>
      <div className={classes.groupBtn}>
        <ButtonSubmit
          saveTemplate={saveTemplate}
          goToTemplateTable={goToTemplateAfterSave}
        />
      </div>
      <PopupAction
        isShow={isShowPopupReset}
        title="dynamicReport.RESET"
        handleClose={() => setIsShowPopupReset(false)}
        btnCancel={{
          label: 'common.NO',
          event: () => setIsShowPopupReset(false),
          isI18n: true,
        }}
        btnSubmit={{
          label: 'dynamicReport.RESET',
          event: reset,
          isI18n: true,
        }}
      >
        <Translate value="dynamicReport.RESET_NOTE" />
      </PopupAction>
      <CheckOutScreen saveTemplate={saveTemplate} ignorePath={path} />
      <Loading />
      <PopupSettingFs />
      <HandleKeepSetting />
    </Element>
  )
}

export default DetailTemplate
